import { journeyAction, } from './base';

import { JourneyActionVoiceStartRecording as JourneyActionVoiceStartRecordingBase, } from 'atlas-shared';

export const JourneyActionVoiceStartRecording = journeyAction({
  ...JourneyActionVoiceStartRecordingBase,
  icon: 'Record',
});
